// import Swiper JS
import Swiper from 'swiper';
import { breakpoint, debounce } from '../../util/helpers';

export default {
  init() {
    this.$contentPackages = document.querySelectorAll('.ms-content-package');
    this.$modules = document.querySelectorAll('.ms-content-package--4-up');
    this.$threeUpModules = document.querySelectorAll('.ms-content-package--3-up');
    this.$oneUpModules = document.querySelectorAll('.ms-content-package--1-up');
    this.carousels = [];
    this.lastBreakpoint = breakpoint();
    
    if (breakpoint() === 'mobile') {
      window.addEventListener('load', () => {
        this.generateSliders();
        this.translateMobileRightImage();
      }, false);
    }
    
    const onResize = debounce(() => {
      this.resizeHandler();
      this.translateMobileRightImage();
    }, 10);
    
    this.alternateOneUp();
    
    window.addEventListener('resize', onResize);
  },
  resizeHandler() {
    if (breakpoint() === this.lastBreakpoint) {
      return;
    }

    else {
      this.lastBreakpoint = breakpoint();
    }

    if (breakpoint() === 'mobile' && this.carousels) {
      this.generateSliders();
    }

    else {
      this.carousels.forEach(carousel => {
        carousel.destroy(true, true);
      });
      this.carousels = [];
    }
  },
  translateMobileRightImage() {
    const $oneUpRightImage = document.querySelectorAll('.ms-content-package--1-up--right figure');

    // if one up right variant does not exist, break out of function
    if (!$oneUpRightImage) return;

    Array.from($oneUpRightImage).map(el => {
      const offset = window.innerWidth - 673 - 16; // 673 as max width of mobile image, 16 as mobile offset

      if (window.innerWidth >= 690) { // mobile image hits its max width at 690px viewport 👌🏻
        el.style.transform = `translateX(${offset}px)`;
      }

      if (breakpoint() !== 'mobile') {
        el.style.removeProperty('transform');
      }
    });
  },
  generateSliders() {
    this.$modules.forEach($module => {
      const $slider = $module.querySelector('.swiper-container');

      if ($slider) {
        const theCarousel = new Swiper($slider, {
          slidesPerView: 1.66,
          slidesToScroll: 1.66,
          slidesPerGroup: 1,
          spaceBetween: 16,
          loop: false,
          a11y: true,
        });

        this.carousels.push(theCarousel);
      }
    });
  },
  alternateOneUp() {
    this.$oneUpModules.forEach(($module, index) => {
      index % 2 === 0 ? $module.classList.add('ms-content-package--1-up--left') : $module.classList.add('ms-content-package--1-up--right');
    });
  },
  truncateText(text, maxChar) {
    const truncatedText = text.textContent.substr(0, maxChar - 1) + '...';

    if (text.textContent.length > maxChar) {
      text.textContent = truncatedText;
    }
  },
  finalize() {
    
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/content-package.js